import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from '@meddatacore/common';
import { ClinicSetting } from "../../models";

@Injectable({ providedIn: 'root' })
export class ClinicSettingService extends ApiService {
    endPoint = '/api/clinic-setting';
    
    create(setting: ClinicSetting): Observable<ClinicSetting> {
        return this.http.post<ClinicSetting>(`${this.clinicsBaseURL}${this.endPoint}`, setting);
    }

    update(setting: ClinicSetting): Observable<ClinicSetting> {
        return this.http.put<ClinicSetting>(`${this.clinicsBaseURL}${this.endPoint}`, setting);
    }

    getClinicSetting(clinicId: string): Observable<ClinicSetting> {
        return this.http.get<ClinicSetting>(`${this.clinicsBaseURL}${this.endPoint}/clinic/${clinicId}`);
    }
}
